// utils/findUrl.ts
export const findUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "") {
    return "https://localhost/chamcore/chameleon/Api/ApiController";
  } else {
    return "https://chamcore.com/chameleon/Api/ApiController";
  }
};